<template>
    <div>
        <div class="row">
            <div class="col-md-3">
                Min Order Total:<br/>
                <input type="number" class="minOrderTotal form-control" v-model="requirement.settings.min_order_total" min="0" />
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        requirement: Object
    }
}
</script>